var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subSuccessfully" },
    [
      _c("img", {
        attrs: { src: require("@/assets/images/faceSuccessful.png"), alt: "" },
      }),
      !_vm.typeName
        ? _c("p", [
            _vm._v(
              "答案已经提交成功，" + _vm._s(_vm.times) + "s后自动返回首页"
            ),
          ])
        : _c("p", [
            _vm._v(
              "系统检查到非法操作，已自动提交试卷，" +
                _vm._s(_vm.times) +
                "s后自动返回首页"
            ),
          ]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.isRouter()
            },
          },
        },
        [_vm._v("返回首页")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }